import InfoService from '@/service/InfoService.js'

/* eslint-disable */
export default class labResultService extends InfoService {
    constructor(ref) {
        super(ref)
    }
    get(id) {
        let url = `${super.baseUrl}v1/labResult/${id}`
        return super.customGet(url)
    }
    list(page, sort, order, searchDto={}) {
        let url = `${super.baseUrl}v1/labResults`
        searchDto.page = page
        searchDto.sort = sort
        searchDto.order = order
        return super.customGet(url, searchDto)
    }
    add(dto){
        let url = `${super.baseUrl}labResult`
        return super.customPost(url, dto)
    }
    update(id, dto) {
        let url = `${super.baseUrl}labResult/${id}`
        return super.customPut(url, dto)
    }
    delete(id) {
        let url = `${super.baseUrl}labResult/${id}`
        return super.customDelete(url)
    }
    export(id) {
        let url = `${super.baseUrl}labResult/export`
        return super.customGetDownload(url)
    }
}



// WEBPACK FOOTER //
// ./src/service/labResultService.js